import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext } from 'react';
import './DragContainer.css';
export const DragContainerContext = createContext({});
export function getIndexOfFocus(container) {
    var _a, _b;
    const dragContainer = document.activeElement && document.activeElement.closest('.dragContainer');
    if (dragContainer && (container === dragContainer || !container)) {
        const draggables = (_a = dragContainer === null || dragContainer === void 0 ? void 0 : dragContainer.querySelectorAll('.draggable')) !== null && _a !== void 0 ? _a : [];
        const draggable = (_b = document.activeElement) === null || _b === void 0 ? void 0 : _b.closest('.draggable');
        const index = Array.from(draggables).indexOf(draggable);
        return index > -1 ? index : undefined;
    }
    return undefined;
}
const DragContainer = ({ className, children, onDrag, onSwap }) => {
    const ref = React.useRef(null);
    return _jsx(DragContainerContext.Provider, { value: { onDrag, onSwap }, children: _jsx("div", { ref: ref, className: `dragContainer ${className !== null && className !== void 0 ? className : ''}`, children: children }) });
};
export default DragContainer;
